import { OnInit, ElementRef } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { ErrorHandlerService } from '../services';
import { DashboardPageInboxCountUpdateService } from '../services';
import './../rxjs-operators';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs/Rx';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { JWT } from '../helpers';
import { DASHBOARDENDPOINTS } from '../environment';
import { Http, Response } from '@angular/http';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { AuthService } from 'angular2-social-login';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(socialAuthService, dashboardService, errorHandlerService, dashboardPageInboxCountUpdateService, location, http, router) {
        this.socialAuthService = socialAuthService;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.dashboardPageInboxCountUpdateService = dashboardPageInboxCountUpdateService;
        this.location = location;
        this.http = http;
        this.router = router;
        // showSubmenuProfile: false;
        this.navFlag = 0;
        this.user = {};
        this.topsearch = false;
        this.searchText = "";
        this.totalNoOfNewNotifications = "";
        this.isTotalNoOfNewNotifications = true;
        this.showLogOffModalDialog = false;
        this.showLogOffMessageTitle = "Session Expired. Logging off!";
        this.showLogOffMessages = [];
        this.showLogOffPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isSessionExpired = false;
        this.deleteduserAccessException = false;
        this.deleteduserAccessExceptionGoBackInHistory = false;
        this.searchTerms = new Subject();
        this.blankSearchResult$ = new Subject();
        this.apiurl = '';
        this.websoketNotificationSockJSConnectionURL = '';
        this.websoketNotificationDataEndpoint = '';
        this.websoketNotificationStompClientSubscriptionQueue = '';
        this.isValidationError = true;
        this.isMenuCompressed = false;
        this.noOfUnreadNotifications = 0;
        this.meetingRequestCalendarEntries = {};
        this.isMyCalendarVisible = false;
        this.myCalendarHtmlContent = "";
        this.dashboardWindowHeight = 0;
        this.dashboardWindowWidth = 0;
        this.myCalendarWindowHeight = 0;
        this.myCalendarWindowWidth = 0;
        this.courseJoinKey = "";
        this.courseJoinPassword = "";
        this.displayCourseJoinCredentials = false;
        // Recommendation
        this.displayWriteRecommendationPopup = false;
        this.recommendationRequestId = "";
        this.recommendationResponseFromUserId = "";
        this.recoResponseToFirstName = "";
        this.recoResponseToLastName = "";
        this.recoResponseToUserTypeFullDescription = "";
        this.recoResponseToEducationalInstitutionFullName = "";
        this.subscriptions = [];
        this.recoResp = { responseFrom: {}, responseTo: {}, recommendation: { recommendation: "" } };
        // Rating
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.ratingRequestId = "";
        this.ratingToFirstName = "";
        this.ratingToLastName = "";
        this.displaySendRatingPopup = false;
        this.apiurl = process.env.API_URL;
        this.websoketNotificationSockJSConnectionURL = process.env.WEBSOCKET_NOTIFICATION_SOCKJS_CONNECTION_URL;
        this.websoketNotificationDataEndpoint = process.env.WEBSOCKET_NOTIFICATION_DATA_ENDPOINT;
        this.websoketNotificationStompClientSubscriptionQueue = process.env.WEBSOCKET_NOTIFICATION_STOMPCLIENT_SUBSCRIPTION_QUEUE;
        this.myCalendarUrl = process.env.HOST_URL + 'meeting/calendar-profile/home';
    }
    DashboardComponent.prototype.onWindowResize = function () {
        var _this = this;
        //debounce resize, wait for resize to finish before doing stuff
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout((function () {
            console.log("this.showCompressedMenuDiv.nativeElement.clientHeight=>" + _this.showCompressedMenuDiv.nativeElement.clientHeight);
            if (_this.showCompressedMenuDiv.nativeElement.clientHeight <= 0) {
                _this.leftMenuElement.nativeElement.style.display = 'block';
            }
            console.log('Resize complete');
        }).bind(this), 800);
    };
    DashboardComponent.prototype.initializeWebSocketConnection = function () {
        var ws = new SockJS(this.websoketNotificationSockJSConnectionURL);
        console.log('Web-Socket: Opening connection to:' + this.websoketNotificationSockJSConnectionURL);
        console.log("JWT token in websocket haha:" + localStorage.getItem('authorization'));
        var header = {
            "jwt-token": localStorage.getItem('authorization')
        };
        this.stompClient = Stomp.over(ws);
        var myStomp = this.stompClient;
        var that = this;
        if (!this.isSessionExpired) {
            this.stompClient.connect(header, function (frame) {
                console.log("Connected to WebSocket");
                console.log("Websocket Frame: " + frame);
                console.log(frame);
                console.log("myStomp");
                console.log(myStomp);
                console.log('Web-Socket: About to subscribe to Queue:' + that.websoketNotificationStompClientSubscriptionQueue);
                myStomp.subscribe(that.websoketNotificationStompClientSubscriptionQueue, function (message) {
                    console.log("Subscribed successfully to websocket");
                    console.log("Received message from the web socket:");
                    console.log(message);
                    if (message != null && message.body) {
                        var newNotificationData = JSON.parse(message.body);
                        console.log("The Websocket data :");
                        console.log(newNotificationData);
                        if (that.notificationData == null) {
                            that.notificationData = newNotificationData;
                            that.noOfUnreadNotifications = that.notificationData.totalNumberOfUnreadNotifications;
                        }
                        else {
                            if (newNotificationData.invitations != null && newNotificationData.invitations.length > 0) {
                                if (that.notificationData.invitations == null || that.notificationData.invitations == undefined) {
                                    that.notificationData.invitations = [{}];
                                }
                                newNotificationData.invitations.forEach(function (invitation) {
                                    console.log("New Invitation:" + invitation);
                                    that.noOfUnreadNotifications = that.noOfUnreadNotifications + 1;
                                    that.notificationData.invitations.push(invitation);
                                });
                            }
                            if (newNotificationData.requests != null && newNotificationData.requests.length > 0) {
                                if (that.notificationData.requests == null || that.notificationData.requests == undefined) {
                                    that.notificationData.requests = [{}];
                                }
                                newNotificationData.requests.forEach(function (request) {
                                    console.log("New Request:" + request);
                                    that.noOfUnreadNotifications = that.noOfUnreadNotifications + 1;
                                    that.notificationData.requests.push(request);
                                });
                            }
                            if (newNotificationData.messages != null && newNotificationData.messages.length > 0) {
                                if (that.notificationData.messages == null || that.notificationData.messages == undefined) {
                                    that.notificationData.messages = [{}];
                                }
                                newNotificationData.messages.forEach(function (message) {
                                    console.log("New Message:" + message);
                                    that.noOfUnreadNotifications = that.noOfUnreadNotifications + 1;
                                    that.notificationData.messages.push(message);
                                });
                            }
                            if (newNotificationData.intimations != null && newNotificationData.intimations.length > 0) {
                                if (that.notificationData.intimations == null || that.notificationData.intimations == undefined) {
                                    that.notificationData.intimations = [{}];
                                }
                                newNotificationData.intimations.forEach(function (intimation) {
                                    console.log("New Intimation:" + intimation);
                                    that.noOfUnreadNotifications = that.noOfUnreadNotifications + 1;
                                    that.notificationData.intimations.push(intimation);
                                });
                            }
                        }
                        console.log("that.meetingRequestCalendarEntries");
                        console.log(that.meetingRequestCalendarEntries);
                    }
                });
                console.log("Successfully connected to Websocket, now going to send message to retrieve stuff.");
                console.log('Web-Socket: About to send messge to endpoint:' + this.websoketNotificationStompClientSubscriptionQueue);
                // The Websocket subscription has been completed. Now, send message to retrieve all notifications.
                that.stompClient.send(that.websoketNotificationDataEndpoint, {}, "hello");
            }, function (error) {
                console.log("STOMP Error occurred:" + error);
            });
        }
    };
    DashboardComponent.prototype.displayMyCalendar = function (requestId) {
        window.open(this.myCalendarUrl, "My Calendar", "width=" + this.myCalendarWindowWidth + ",height=" + this.myCalendarWindowHeight);
    };
    DashboardComponent.prototype.getDisplay = function (showSubmenu) {
        if (showSubmenu) {
            return "block";
        }
        else {
            return "none";
        }
    };
    DashboardComponent.prototype.searchBlur = function () {
        var _this = this;
        setTimeout(function () {
            _this.topsearch = false;
            _this.searchText = "";
            _this.searchTerms.next(_this.searchText);
        }, 200);
    };
    DashboardComponent.prototype.topSearch = function () {
        if (this.searchText.trim() == "") {
            this.topsearch = false;
        }
        this.searchTerms.next(this.searchText);
    };
    DashboardComponent.prototype.searchClick = function (text) {
        this.searchBlur();
        this.router.navigate(['dashboard/search'], { queryParams: { fname: text } });
    };
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dashboardWindowHeight = window.innerHeight;
        this.dashboardWindowWidth = window.innerWidth;
        this.myCalendarWindowHeight = Math.floor(this.dashboardWindowHeight * 0.80);
        this.myCalendarWindowWidth = Math.floor(this.dashboardWindowWidth * 0.80);
        this.showSpinner = true;
        //console.log('inside ngOnInit()');
        this.processAndHandleErrorThrown();
        this.listenToInboxUpdateEvents();
        this.blankSearchResult$.next({ "isNotValid": "true" });
        this.searchResult$ = this.searchTerms.pipe(
        // wait 300ms after each keystroke before considering the term
        debounceTime(1000), 
        // ignore new term if same as previous term
        distinctUntilChanged(), 
        // switch to new search observable each time the term changes
        switchMap(function (term) {
            if (term.trim() != "") {
                return _this.http.get(_this.apiurl + DASHBOARDENDPOINTS.topSearchget + term, JWT.jwt()).map(function (response) {
                    _this.topsearch = true;
                    return response.json();
                });
            }
            else {
                _this.topsearch = false;
                return _this.blankSearchResult$.map(function (response) {
                    return response.json();
                });
            }
        }));
        this.userSummarySubscriber = this.dashboardService.loggedInUserDataForWebsocket().subscribe(function (data) {
            console.log("Subscribing to user event for web socket. Event received");
            _this.user = data;
            _this.showSpinner = false;
            console.log("UserData" + _this.user);
            console.log("Will invoke web socket initialization routine");
            _this.initializeWebSocketConnection();
        });
        this.updateDashboardCount();
        this.inboxDashSubscriber = Observable.interval(500 * 60).subscribe(function (x) {
            _this.updateDashboardCount();
        }, function (error) { _this.handleError(error); });
        this.sessionExpiryCheckerSubscriber = Observable.interval(1000 * 60).subscribe(function (x) {
            _this.dashboardService.pollSessionExpiryCheck().subscribe(function (data) {
            }, function (error) {
                _this.sessionExpiryCheckerSubscriber.unsubscribe();
                _this.handleError(error);
            });
        }, function (error) { _this.handleError(error); });
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        if (!this.inboxDashSubscriber.closed) {
            this.inboxDashSubscriber.unsubscribe();
        }
        if (!this.sessionExpiryCheckerSubscriber.closed) {
            this.sessionExpiryCheckerSubscriber.unsubscribe();
        }
        if (!this.thrownErrorCheckerSubscriber.closed) {
            this.thrownErrorCheckerSubscriber.unsubscribe();
        }
        if (!this.inboxCountUpdateSubscriber.closed) {
            this.inboxCountUpdateSubscriber.unsubscribe();
        }
        if (!this.userSummarySubscriber.closed) {
            this.userSummarySubscriber.unsubscribe();
        }
        if (!this.isSessionExpired && this.stompClient != undefined) {
            this.stompClient.disconnect(function () {
                console.log("logging off from websocket");
            });
        }
    };
    DashboardComponent.prototype.acceptconReq = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.connAccept(notificationItemBusinessKey).subscribe(function (data) {
            _this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
                _this.removeInvitation(notificationItemBusinessKey, event);
                _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            }, function (error) {
                _this.handleNotficationError(error);
            });
        }, function (error) {
            _this.handleError(error);
        });
    };
    DashboardComponent.prototype.acceptMeetingReq = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        var meetingId = notificationItemBusinessKey;
        var meetingAcceptCode = "2";
        if (meetingId != null) {
            var meetingAcceptReqData = { code: meetingAcceptCode, eventId: meetingId };
            this.dashboardService.meetingReqAccept(meetingAcceptReqData).subscribe(function (data) {
                _this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
                    _this.removeRequest(notificationItemBusinessKey, event);
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }, function (error) {
                    _this.handleNotficationError(error);
                });
            }, function (error) {
                _this.handleError(error);
            });
        }
    };
    DashboardComponent.prototype.rejectMeetingReq = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        var meetingId = notificationItemBusinessKey;
        var meetingRejectCode = "3";
        var meetingRejectReason = "Rejected By User.";
        if (meetingId != null) {
            var meetingRejectReqData = { code: meetingRejectCode, eventId: meetingId, rejectReason: meetingRejectReason };
            this.dashboardService.meetingReqReject(meetingRejectReqData).subscribe(function (data) {
                _this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
                    _this.removeRequest(notificationItemBusinessKey, event);
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }, function (error) {
                    _this.handleNotficationError(error);
                });
            }, function (error) {
                _this.handleError(error);
            });
        }
    };
    DashboardComponent.prototype.cancelSendResponseForRecommendationRequest = function () {
        this.resetRecommendationResponseData();
        this.showSpinner = false;
        this.showOnlyOverlay = false;
    };
    DashboardComponent.prototype.resetRecommendationResponseData = function () {
        this.displayWriteRecommendationPopup = false;
        this.recommendationRequestId = "";
        this.recommendationResponseFromUserId = "";
        this.displaySendRatingPopup = false;
        this.recoResponseToFirstName = "";
        this.recoResponseToLastName = "";
        this.recoResponseToUserTypeFullDescription = "";
        this.recoResponseToEducationalInstitutionFullName = "";
        this.recoResp = { responseFrom: {}, responseTo: {}, recommendation: { recommendation: "" } };
    };
    DashboardComponent.prototype.sendResponseForRecommendationRequest = function () {
        var _this = this;
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        var request = this.notificationData.requests[this.getMatchingRequestIndex(this.recommendationRequestId, 'RECOMMENDATION_REQUEST')];
        if (request != null && request != undefined) {
            this.recoResp.responseFrom.userDetailsId = this.recommendationResponseFromUserId;
            this.recoResp.responseTo.userDetailsId = request.displayUserDetailsId;
            var s1 = this.dashboardService.sendRecommendationForRequest(this.recoResp, this.recommendationRequestId).subscribe(function (data) {
                var s2 = _this.dashboardService.markNotificationRead(_this.recommendationResponseFromUserId, 'RECOMMENDATION_REQUEST', _this.recommendationRequestId).subscribe(function (data) {
                    _this.removeRequest(_this.recommendationRequestId, 'RECOMMENDATION_REQUEST');
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                    _this.resetRecommendationResponseData();
                    _this.showSpinner = false;
                    _this.showOnlyOverlay = false;
                }, function (error) {
                    _this.showSpinner = false;
                    _this.showOnlyOverlay = false;
                    _this.resetRecommendationResponseData();
                    _this.handleNotficationError(error);
                });
                _this.subscriptions.push(s2);
            }, function (error) {
                _this.resetRecommendationResponseData();
                _this.showSpinner = false;
                _this.showOnlyOverlay = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s1);
        }
    };
    DashboardComponent.prototype.showWriteRecommendationDialog = function (userId, notificationItemBusinessKey) {
        this.recommendationRequestId = notificationItemBusinessKey;
        this.recommendationResponseFromUserId = userId;
        var request = this.notificationData.requests[this.getMatchingRequestIndex(this.recommendationRequestId, 'RECOMMENDATION_REQUEST')];
        if (request != null && request != undefined) {
            this.recoResponseToFirstName = request.firstName;
            this.recoResponseToLastName = request.lastName;
            this.recoResponseToUserTypeFullDescription = request.userType;
            this.recoResponseToEducationalInstitutionFullName = request.userEducationalInstitution;
        }
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        this.displayWriteRecommendationPopup = true;
    };
    DashboardComponent.prototype.showSendRatingDialog = function (userId, notificationItemBusinessKey) {
        this.ratingRequestId = notificationItemBusinessKey;
        this.displaySendRatingPopup = true;
        var request = this.notificationData.requests[this.getMatchingRequestIndex(notificationItemBusinessKey, 'RATING_REQUEST')];
        if (request != null && request != undefined) {
            this.ratingToFirstName = request.firstName;
            this.ratingToLastName = request.lastName;
        }
        this.showSpinner = true;
        this.showOnlyOverlay = true;
    };
    DashboardComponent.prototype.resetRatingResponseData = function () {
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.ratingRequestId = "";
        this.ratingToFirstName = "";
        this.ratingToLastName = "";
        this.displaySendRatingPopup = false;
    };
    DashboardComponent.prototype.cancelRating = function () {
        this.resetRatingResponseData();
        this.showSpinner = false;
        this.showOnlyOverlay = false;
    };
    DashboardComponent.prototype.sendRating = function () {
        var _this = this;
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        var userId = this.notificationData.notificationReceiverUserDetailsId;
        var request = this.notificationData.requests[this.getMatchingRequestIndex(this.ratingRequestId, 'RATING_REQUEST')];
        if (request != null && request != undefined) {
            this.rating.responseFrom.userDetailsId = userId;
            this.rating.responseTo.userDetailsId = request.displayUserDetailsId;
            var s3 = this.dashboardService.sendRatingForRequest(this.rating, this.ratingRequestId).subscribe(function (data) {
                var s4 = _this.dashboardService.markNotificationRead(userId, 'RATING_REQUEST', _this.ratingRequestId).subscribe(function (data) {
                    _this.removeRequest(_this.ratingRequestId, 'RATING_REQUEST');
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                    _this.resetRatingResponseData();
                    _this.showSpinner = false;
                    _this.showOnlyOverlay = false;
                }, function (error) {
                    _this.resetRatingResponseData();
                    _this.showSpinner = false;
                    _this.showOnlyOverlay = false;
                    _this.handleNotficationError(error);
                });
                _this.subscriptions.push(s4);
            }, function (error) {
                _this.resetRatingResponseData();
                _this.showSpinner = false;
                _this.showOnlyOverlay = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s3);
        }
    };
    DashboardComponent.prototype.performCreateCourse = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            _this.removeRequest(notificationItemBusinessKey, event);
            _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            _this.router.navigate(['/dashboard/createcourse']);
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.performViewMessage = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            _this.removeMessage(notificationItemBusinessKey, event);
            _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            _this.gotoInbox();
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.performViewRecommendation = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            _this.removeMessage(notificationItemBusinessKey, event);
            _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            _this.gotoInbox();
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.performViewCourse = function (courseId) {
        this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + courseId);
    };
    DashboardComponent.prototype.performViewCourseReviews = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            _this.removeImportant(notificationItemBusinessKey, event);
            _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            _this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + notificationItemBusinessKey + "&isReviewToBeDisplayed=" + 'true');
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.performViewCourseAttendees = function (userId, event, notificationItemBusinessKey) {
        var _this = this;
        this.dashboardService.markNotificationRead(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            _this.removeImportant(notificationItemBusinessKey, event);
            _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
            _this.router.navigateByUrl('/dashboard/attendees?courseId=' + notificationItemBusinessKey.split('-')[0]);
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.removeInvitation = function (id, event) {
        var index = this.getMatchingInvitationIndex(id, event);
        if (index >= 0) {
            this.notificationData.invitations.splice(index, 1);
            return true;
        }
        return false;
    };
    DashboardComponent.prototype.removeRequest = function (id, event) {
        var index = this.getMatchingRequestIndex(id, event);
        if (index >= 0) {
            this.notificationData.requests.splice(index, 1);
            return true;
        }
        return false;
    };
    DashboardComponent.prototype.removeMessage = function (id, event) {
        var index = this.getMatchingMessageIndex(id, event);
        if (index >= 0) {
            this.notificationData.messages.splice(index, 1);
            return true;
        }
        return false;
    };
    DashboardComponent.prototype.removeImportant = function (id, event) {
        var index = this.getMatchingIntimationIndex(id, event);
        if (index >= 0) {
            this.notificationData.intimations.splice(index, 1);
            return true;
        }
        return false;
    };
    DashboardComponent.prototype.ignoreNotification = function (userId, event, notificationItemBusinessKey, notificationType) {
        var _this = this;
        this.dashboardService.ignoreNotification(userId, event, notificationItemBusinessKey).subscribe(function (data) {
            if (notificationType == 'INVITATION') {
                if (_this.removeInvitation(notificationItemBusinessKey, event)) {
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }
            }
            else if (notificationType == 'REQUEST') {
                if (_this.removeRequest(notificationItemBusinessKey, event)) {
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }
            }
            else if (notificationType == 'MESSAGE') {
                if (_this.removeMessage(notificationItemBusinessKey, event)) {
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }
            }
            else if (notificationType == 'INTIMATION') {
                if (_this.removeImportant(notificationItemBusinessKey, event)) {
                    _this.noOfUnreadNotifications = _this.noOfUnreadNotifications - 1;
                }
            }
        }, function (error) {
            _this.handleNotficationError(error);
        });
    };
    DashboardComponent.prototype.getMatchingInvitationIndex = function (id, event) {
        var size = this.notificationData.invitations.length;
        for (var index = 0; index < size; ++index) {
            var invitation = this.notificationData.invitations[index];
            if (invitation.id == id && invitation.event == event) {
                return index;
            }
        }
        return -1;
    };
    DashboardComponent.prototype.getMatchingRequestIndex = function (id, event) {
        var size = this.notificationData.requests.length;
        for (var index = 0; index < size; ++index) {
            var request = this.notificationData.requests[index];
            if (request.id == id && request.event == event) {
                return index;
            }
        }
        return -1;
    };
    DashboardComponent.prototype.getMatchingMessageIndex = function (id, event) {
        var size = this.notificationData.messages.length;
        for (var index = 0; index < size; ++index) {
            var message = this.notificationData.messages[index];
            if (message.id == id && message.event == event) {
                return index;
            }
        }
        return -1;
    };
    DashboardComponent.prototype.getMatchingIntimationIndex = function (id, event) {
        var size = this.notificationData.intimations.length;
        for (var index = 0; index < size; ++index) {
            var intimation = this.notificationData.intimations[index];
            if (intimation.id == id && intimation.event == event) {
                return index;
            }
        }
        return -1;
    };
    DashboardComponent.prototype.updateDashboardCount = function () {
        var _this = this;
        this.dashboardService.pollLoggedInUser().subscribe(function (data) {
            _this.totalNoOfNewNotifications = data.totalNoOfNewNotifications;
            if (_this.totalNoOfNewNotifications == '0') {
                _this.isTotalNoOfNewNotifications = false;
            }
            else {
                _this.isTotalNoOfNewNotifications = true;
            }
            console.log("this.totalNoOfNewNotifications" + _this.totalNoOfNewNotifications);
            console.log("Last time user accessed Uvsity ==>" + data.timeOfCreationText);
        }, function (error) { console.log(error); _this.handleError(error); _this.inboxDashSubscriber.unsubscribe(); });
    };
    DashboardComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    DashboardComponent.prototype.displayMeetingCredentials = function (courseJoinKey, courseJoinPassword) {
        this.courseJoinKey = courseJoinKey;
        this.courseJoinPassword = courseJoinPassword;
        this.displayCourseJoinCredentials = true;
    };
    DashboardComponent.prototype.googleLogout = function () {
        var _this = this;
        gapi.load('auth2', function () {
            _this.auth2 = gapi.auth2.getAuthInstance();
            _this.auth2.signOut().then(function () {
                console.log("User signed out");
            });
            _this.auth2.disconnect();
            //this.attachSignout(document.getElementById('googleBtn2'));
        });
    };
    // Glogout() {
    //   this.socialAuthService.logout().subscribe(
    //     (data) => { console.log(data) }
    //   )
    // }
    DashboardComponent.prototype.logout = function () {
        var _this = this;
        console.log('Logging Out');
        console.log("The Auth Header in localstorage in dashbord component==>" + localStorage.getItem('authorization'));
        this.dashboardService.logOff().subscribe(function (data) {
            _this.googleLogout();
        }, function (error) {
            console.log("Error in calling the Logoff Service");
            console.log(error);
        });
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showLogOffModalDialog = false;
        console.log("Removing the Authorization JWT token from LocalStorage");
        localStorage.removeItem('authorization');
        console.log("Navigating to Login page");
        this.router.navigate(['/login', 'true']);
    };
    DashboardComponent.prototype.closeErrorMessagePopup = function () {
        console.log("After closing Error Popup");
        // Trying to access whose account has been deleted.
        if (this.deleteduserAccessException) {
            // Cannot view the User's profile, go back to where you came from.
            this.deleteduserAccessException = false;
            this.showSpinner = false;
            this.showOnlyOverlay = false;
            this.showLogOffModalDialog = false;
            this.showLogOffMessages = [];
            if (this.deleteduserAccessExceptionGoBackInHistory == true) {
                this.location.back();
            }
        }
        else if (this.isSessionExpired) {
            console.log("Session expired, About to Logout");
            this.isSessionExpired = false;
            this.logout();
        }
        else {
            console.log("Session did not expire, will remove the overlay");
            this.showSpinner = false;
            this.showOnlyOverlay = false;
            this.showLogOffModalDialog = false;
            this.showLogOffMessages = [];
        }
    };
    DashboardComponent.prototype.processAndHandleErrorThrown = function () {
        var _this = this;
        this.thrownErrorCheckerSubscriber = this.errorHandlerService.errorMessage$.subscribe(function (error) {
            _this.handleError(error);
        });
    };
    DashboardComponent.prototype.listenToInboxUpdateEvents = function () {
        var _this = this;
        this.inboxCountUpdateSubscriber = this.dashboardPageInboxCountUpdateService.inobxCount$.subscribe(function (inboxCountUpdateData) {
            _this.totalNoOfNewNotifications = inboxCountUpdateData.totalNoOfNewNotifications;
            if (_this.totalNoOfNewNotifications == '0') {
                _this.isTotalNoOfNewNotifications = false;
            }
            console.log("this.totalNoOfNewNotifications from listenToInboxUpdateEvents:" + _this.totalNoOfNewNotifications);
        });
    };
    DashboardComponent.prototype.showHideMenuWhenCompressed = function () {
        this.isMenuCompressed = true;
        console.log("Menu is compressed and has been clicked~~~~isMenuCompressed==>" + this.isMenuCompressed);
        console.log('leftMenuElement.nativeElement.style.display==>' + this.leftMenuElement.nativeElement.style.display);
        if (this.leftMenuElement.nativeElement.style.display == 'block') {
            this.leftMenuElement.nativeElement.style.display = 'none';
        }
        else {
            this.leftMenuElement.nativeElement.style.display = 'block';
        }
    };
    DashboardComponent.prototype.hideMenuIfRequired = function () {
        if (this.showCompressedMenuDiv.nativeElement.clientHeight > 0) {
            this.showHideMenuWhenCompressed();
        }
    };
    DashboardComponent.prototype.gotoHome = function () {
        console.log('gotoHome invoked, routing to dashboard/home');
        this.hideMenuIfRequired();
        this.router.navigate(['dashboard/home']);
    };
    DashboardComponent.prototype.gotoViewProfile = function () {
        console.log('gotoViewProfile invoked, routing to dashboard/viewprofile');
        this.hideMenuIfRequired();
        this.router.navigate(['dashboard/viewprofile']);
    };
    DashboardComponent.prototype.gotoEditProfile = function () {
        console.log('gotoEditProfile invoked, routing to dashboard/editProfile');
        this.hideMenuIfRequired();
        this.router.navigate(['dashboard/editProfile']);
    };
    DashboardComponent.prototype.gotoMyConnections = function () {
        console.log('gotoMyConnections invoked, routing to dashboard/myconnections');
        this.hideMenuIfRequired();
        var navigationExtras = {
            queryParams: { 'i': 'true' }
        };
        this.router.navigate(['dashboard/myconnections'], navigationExtras);
    };
    DashboardComponent.prototype.gotoAddConnections = function () {
        console.log('gotoAddConnections invoked, routing to dashboard/addconnections');
        this.hideMenuIfRequired();
        this.router.navigate(['dashboard/addconnections']);
    };
    DashboardComponent.prototype.gotoInbox = function () {
        console.log('gotoInbox invoked, routing to dashboard/inbox');
        this.hideMenuIfRequired();
        this.router.navigate(['dashboard/inbox']);
    };
    DashboardComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    DashboardComponent.prototype.handleNotficationError = function (error) {
        this.showOnlyOverlay = true;
        this.showLogOffMessageTitle = "Info";
        console.log('error._body');
        console.log(error._body);
        this.showLogOffMessages.push(error._body);
        this.showLogOffPopupWidthInPercentage = "30%";
        this.showLogOffModalDialog = true;
    };
    DashboardComponent.prototype.handleError = function (error) {
        var _this = this;
        // Clear the error message list. Everytime this is invoked, it will remove the existing errors.
        this.showLogOffMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        //if this is an error thrown due to user accessing a deleted user's profile
        if (error.userDeleted) {
            console.log("Deleted User Access Exception, catching error thrown from ViewProfileAuthGuard");
            this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.deleteduserAccessException = true;
            this.showLogOffMessageTitle = "Validation Error !!";
            this.showLogOffMessages.push("Sorry, the user has deleted his / her account. We are unable to display his / her profile.");
            this.showLogOffPopupWidthInPercentage = "30%";
            this.showLogOffModalDialog = true;
            this.deleteduserAccessExceptionGoBackInHistory = false;
            return;
        }
        // if it's a info message
        if (error.isInfo) {
            console.log("Info Message");
            this.isValidationError = false;
            this.showSpinner = true;
            this.showOnlyOverlay = true;
            this.showLogOffMessageTitle = "Info";
            this.showLogOffMessages.push(error.infoMessage);
            this.showLogOffPopupWidthInPercentage = "30%";
            this.showLogOffModalDialog = true;
            return;
        }
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.deleteduserAccessException) {
                console.log("Deleted User Access Exception");
                this.deleteduserAccessException = true;
                this.showLogOffMessageTitle = "Validation Error !!";
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
                this.deleteduserAccessExceptionGoBackInHistory = true;
            }
            else if (errorJson.sessionExpired) {
                console.log("The session has expired, so will display the Session Logout Popup now");
                this.isSessionExpired = true;
                this.showLogOffMessages = ["The session expired. Logging off now! Please log in back to the application."];
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
            }
            else {
                if (this.isSessionExpired) {
                    // If session expired, and dialog is not open, display the dialog once more. This scenario though would be
                    // hard to come by as the page will redirect to Login screen once the user closes the dialog.
                    if (!this.showLogOffModalDialog) {
                        console.log("The session has expired, so will display the Session Logout Popup now");
                        this.isSessionExpired = true;
                        this.showLogOffMessages = ["The session expired. Logging off now! Please log in back to the application."];
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                }
                else {
                    if (errorJson.Uvsity_Errors) {
                        console.log("Uvsity Exception");
                        this.showLogOffMessageTitle = "Validation Error !!";
                        errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                    else if (errorJson.Uvsity_Errors_Stacktrace) {
                        console.log("Uvsity Exception containing stacktrace");
                        this.showLogOffMessageTitle = "Validation Error !!";
                        errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                        this.isValidationError = false;
                    }
                    else {
                        console.log("Not Uvsity Exception");
                        this.showLogOffMessageTitle = "Unknown Error !!";
                        this.showLogOffMessages.push("An unexpected error occurred, Please try after sometime.");
                        this.showLogOffPopupWidthInPercentage = "30%";
                        this.showLogOffModalDialog = true;
                    }
                }
            }
        }
        else {
            var errorJson = error;
            if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                this.showLogOffMessageTitle = "Validation Error !!";
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showLogOffMessages.push(uvsityError); });
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showLogOffMessageTitle = "Unknown Error !!";
                this.showLogOffMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showLogOffPopupWidthInPercentage = "30%";
                this.showLogOffModalDialog = true;
            }
        }
    };
    return DashboardComponent;
}());
export { DashboardComponent };
//# sourceMappingURL=dashboard.component.js.map